/**
 * Posts a message to both the parent iframe (window.parent.postMessage)
 * and the Flutter WebView JavaScript Channel (AulaniExperienciesMessageHandler).
 *
 * @param {Object} data - The message payload (must include `source` and `type`)
 */
export default function postActiviterMessage(data) {
    const message = { source: 'ACTIVITER_APP', ...data };

    // Iframe parent (postMessage)
    if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*');
    }

    // Flutter WebView JavaScript Channel
    if (window.AulaniExperienciesMessageHandler?.postMessage) {
        window.AulaniExperienciesMessageHandler.postMessage(JSON.stringify(message));
    }
}
